module.exports = __webpack_public_path__ + "img/download-3-panel-1.bb084e4f.png";